import { Component } from '@angular/core';

@Component({
  selector: 'app-overlay-loading-spinner',
  standalone: true,
  imports: [],
  templateUrl: './overlay-loading-spinner.component.html',
  styleUrl: './overlay-loading-spinner.component.scss'
})
export class OverlayLoadingSpinnerComponent {

}
